import { render, staticRenderFns } from "./CarouselView.vue?vue&type=template&id=51e0c0c4"
import script from "./CarouselView.vue?vue&type=script&lang=ts"
export * from "./CarouselView.vue?vue&type=script&lang=ts"
import style0 from "./CarouselView.vue?vue&type=style&index=0&id=51e0c0c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports